<template>
<span>

    <v-dialog v-model="dialog" width="500">
        <v-card>
            <v-card-title class="text-h6 lighten-2">
                Usuários que podem ver esse arquivo
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="mt-8">
                <v-card v-for="(usuario, index) in usuarios" :key="index">
                <p class="lime--text mb-0" v-if="usuario.usu_admin">{{usuario.usu_nome}} - Admin</p>
                <p class="blue-grey--text mb-0" v-if="!usuario.usu_admin">{{usuario.usu_nome}}</p>
                </v-card>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialog = false">
                    fechar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <form-download-file v-on:atualizar="atualizarDownloads" :download_category="download_category"></form-download-file>

    <v-container fluid>
        <v-divider class="mb-6"></v-divider>
        <v-row>

            <v-col cols="12" xs="12" sm="6" md="6" lg="4" xl="3" v-for="(arquivo, index) in download_category.downloads" :key="index" pa-2>
                <v-card class="text-center">
                    <v-flex class="vcard">
                        <!--<a :href="`${base_url}upload/download/${arquivo.down_arquivo}`" target="_blank">-->
                        <v-img class="img-preview mb-3" :src="`${base_url}upload/${arquivo.down_extensao}.png`" width="100"></v-img>
                        <!--</a>-->
                        <p class="mb-0">{{arquivo.down_nome}}</p>
                        <small>{{arquivo.created_at}}</small>
                    </v-flex>

                    <v-card-actions class="justify-center">
                        <v-tooltip bottom color="black lime--text">
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon @click.prevent="destroyDownload(arquivo, index)">highlight_off</v-icon>
                                </v-btn>
                            </template>
                            <span>Excluir Arquivo</span>
                        </v-tooltip>
                        <a :href="`${base_url}upload/download/${arquivo.down_arquivo}`" target="_blank" class="link-arquivo">
                            <v-tooltip bottom color="black lime--text">
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on">
                                        <v-icon>download</v-icon>
                                    </v-btn>
                                </template>
                                <span>Baixar Arquivo</span>
                            </v-tooltip>
                        </a>
                        <v-tooltip bottom color="black lime--text">
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon @click.prevent="verUsuarios(arquivo)">group</v-icon>
                                </v-btn>
                            </template>
                            <span>Usuários desse Arquivo</span>
                        </v-tooltip>
                    </v-card-actions>

                </v-card>

            </v-col>

        </v-row>
    </v-container>

</span>
</template>

<script>
import {
    URL_BASE
} from '../../../../config/configs'
import FormDownloadFileComponent from "./FormDownloadFileComponent";

export default {
    name: "GaleriaDownloadCategoryFileComponent",
    props: {
        download_category: {
            require: false,
            type: Object | Array,
            default: () => {
                return {
                    down_c_id: '',
                    down_c_nome: '',
                }
            },
        },
        require: true,
    },

    data() {
        return {
            downloadFile: {
                require: false,
                type: Object | Array,
                default: () => {
                    return {
                        down_id: '',
                        download_category_id: '',
                        down_nome: '',
                        down_descricao: '',
                        down_extensao: '',
                        down_arquivo: '',
                        down_icone: '',
                        down_imagem: '',
                        down_clicks: '',
                        down_status: '',
                    }
                }
            },
            base_url: URL_BASE,
            dialog: false,
            usuarios: null
        }
    },

    methods: {
        verUsuarios(arquivo) {
            this.usuarios = arquivo.users;
            this.dialog = true;
        },
        atualizarDownloads() {
            this.$emit('atualiza')
        },
        destroyDownload(item, index) {
            this.$swal({
                title: 'Você tem certeza?',
                text: "Você não poderá reverter isso",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#D32F2F',
                cancelButtonColor: '#1976D2',
                confirmButtonText: 'Sim, Exclua!'
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch('destroyDownload', item.down_id)
                        .then(response => {
                            if (response.data) {
                                this.download_category.downloads.splice(index, 1);
                            } else {
                                this.$swal({
                                    position: "center",
                                    icon: "error",
                                    title: 'Opssss!',
                                    text: 'Erro ao excluir dados',
                                    showConfirmButton: true,
                                    timer: 6000
                                });
                            }
                        })
                        .catch(error => {
                            console.log(error)
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: 'Opssss!',
                                text: 'Algo errado aconteceu!',
                                showConfirmButton: true,
                                timer: 6000
                            });
                        })
                }
            })

        },
    },
    components: {
        formDownloadFile: FormDownloadFileComponent,
    }
};
</script>

<style scoped>
.link-arquivo {
    text-decoration: none;
}

.theme--dark.v-sheet {
    background-color: #303030;
    border-color: #303030;
    color: #fff;
    box-shadow: none;
}

.btn-upload,
.btn-salvar {
    margin: 0;
}

/*Also*/
.fileinput-button input {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    opacity: 0;
    -ms-filter: 'alpha(opacity=0)';
    filter: 'alpha(opacity=0)';
    font-size: 200px;
    direction: ltr;
    cursor: pointer;
}

.img-preview {
    max-width: 100%;
    margin: 0 auto;
}

.vcard {
    border: thin sold #FF0000;
}
</style>
